import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';
import type { Invoice, InvoiceStore } from '@/types/invoice';

// Define the initial state using that type
const initialState: InvoiceStore = {
	cartedInvoices: [],
	selectedInvoices: [],
	achAgreementForm: {
		accountName: '',
		financialInstitution: '',
		bank: '',
		routingNumber: '',
		accountNumber: '',
		accountType: '',
		accountType2: '',
		frequency: '',
		amount: '',
		startDate: '',
		dateOfDebit: '',
		typeIndividualName: '',
		signature: '',
		date: '',
	},
	paymentType: '',
};

interface InvoiceCartActions {
	addInvoice: (invoice: Invoice) => void;
	removeInvoice: (id: string) => void;
	clearCart: () => void;
	setPaymentType: (paymentType: string) => void;
}
// Define the shape of your store
export const useInvoiceCartStore = create<InvoiceStore & InvoiceCartActions>()(
	devtools(
		persist(
			(set) => ({
				...initialState,
				addInvoice: (invoice: Invoice) =>
					set((state) => {
						const updatedCartState =
							invoice.pendingPayment || invoice.QBAmtDue <= 0
								? [...state.cartedInvoices]
								: [...state.cartedInvoices, invoice];

						return {
							cartedInvoices: updatedCartState,
							selectedInvoices: [...state.selectedInvoices, invoice],
						};
					}),
				removeInvoice: (id: string) =>
					set((state) => {
						console.log(state);
						return {
							cartedInvoices: state.cartedInvoices.filter(
								(invoice) => invoice.InvoiceID !== id,
							),
							selectedInvoices: state.selectedInvoices.filter(
								(invoice) => invoice.InvoiceID !== id,
							),
						};
					}),
				setPaymentType: (paymentType: string) =>
					set(() => ({
						paymentType,
					})),
				clearCart: () =>
					set(() => ({
						cartedInvoices: [],
						selectedInvoices: [],
					})),
			}),
			{
				// ✅ blacklist example
				partialize: (state) => ({
					selectedInvoices: state.selectedInvoices,
					cartedInvoices: state.cartedInvoices,
					achAgreementForm: state.achAgreementForm,
					paymentType: state.paymentType,
				}),
				name: 'invoice-cart-storage',
			},
		),
		{ name: 'InvoiceCart' },
	),
);
